import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bottomArrow",
  "use": "icon-bottomArrow-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-bottomArrow\">\n<title>bottomArrow</title>\n<path fill=\"#6dbcc2\" d=\"M2.049 9.025l13.951 13.951 13.951-13.951z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol